import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/university/marketplace/$skillId')({

}).lazy(() => import('./$skillId.lazy').then((d) => d.Route));
